/**
 * Default support message for when an answer is not found initially
 */
export const DEFAULT_SUPPORT_MESSAGE_NOT_FOUND =
  '*Support needed* — A team member will help you shortly';

/**
 * Default support message for when an answer is provided but marked as not helpful
 */
export const DEFAULT_SUPPORT_MESSAGE_NOT_HELPFUL =
  '*Support needed* — A team member will help you shortly';

// Legacy DEFAULT_SUPPORT_MESSAGE has been removed
